import React from 'react';
import { SplitLayout } from '../components/layout/SplitLayout';

function Home() {
  return <SplitLayout />;
}

export default Home;
